import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { COLUMNSWIDTH, CustomField } from 'modules/employees/pages/EditInBulk/types'

import type { ColumnNames } from '../../../vars'
import type { DataTableColumnsType } from './DataTable'

interface Field {
  label: string
  key: ColumnNames
  information?: string
}

function columns(
  legalEntitiesCount?: number,
  employeeGroupsCount?: number,
  customFields?: CustomField[]
): DataTableColumnsType {
  const width = COLUMNSWIDTH

  const defaultFields: Field[] = [
    {
      label: i18n.t('employees.bulk_edit.profile.default_workplace'),
      key: 'office',
    },
    {
      label: i18n.t('employees.bulk_edit.profile.team'),
      key: 'team',
    },
    {
      label: i18n.t('employees.bulk_edit.profile.manager'),
      key: 'manager',
    },
    {
      label: i18n.t('employees.bulk_edit.profile.time_off_supervisor'),
      key: 'time_off_supervisor',
    },
    {
      label: i18n.t('employees.bulk_edit.profile.permission_group'),
      key: 'permission_group',
    },
  ]

  const legalEntityAndEmployeeGroupPresent =
    (legalEntitiesCount ?? 0) > 1 && (employeeGroupsCount ?? 0) > 1

  const legalEntityAndEmployeeGroupLabel = () => {
    if (legalEntityAndEmployeeGroupPresent) {
      return i18n.t('employees.bulk_edit.profile.legal_entity_and_employee_group')
    } else if ((legalEntitiesCount ?? 0) > 1) {
      return i18n.t('employees.bulk_edit.profile.legal_entity')
    } else {
      return i18n.t('employees.bulk_edit.profile.employee')
    }
  }

  const legalEntityAndEmployeeGroup: Field = {
    label: legalEntityAndEmployeeGroupLabel(),
    key: 'legal_entity_and_employee_group',
  }

  const welcomeSpace: Field = {
    label: i18n.t('employees.bulk_edit.profile.welcome_space.title'),
    information: i18n.t('employees.bulk_edit.profile.welcome_space.info'),
    key: 'regular_access_starts_on',
  }

  const addCustomFieldsColumns = () => {
    const customFieldsColumns: Field[] =
      customFields
        ?.map((customField) => {
          return {
            label: customField.labelText ?? '',
            key: customField.id.toString(),
          }
        })
        .filter(Boolean) || []

    return defaultFields.push(...customFieldsColumns)
  }

  if ((legalEntitiesCount ?? 0) > 1 || (employeeGroupsCount ?? 0) > 1)
    defaultFields.unshift(legalEntityAndEmployeeGroup)
  if (hasFeature('employee_onboarding')) defaultFields.push(welcomeSpace)
  if (hasFeature('custom_fields_in_edit_in_bulk') && !!customFields?.length) {
    addCustomFieldsColumns()
  }

  const dataCells = defaultFields.map((header) => {
    return {
      headerCell: header.label,
      key: header.key,
      information: header.information,
      width:
        header.key === 'legal_entity_and_employee_group' && legalEntityAndEmployeeGroupPresent
          ? width * 2
          : width,
    }
  })

  return [
    {
      headerCell: i18n.t('common.employee'),
      key: 'employee',
      width: 270,
    },
    ...dataCells,
  ]
}

export default columns
